
<template>
    <div id="app" class="app-flex-layout">
        <NavBarComponent />
        <div class="main-content">
          <router-view />
        </div>
        <FooterSectionComponent />
    </div>
</template>

<script>
import NavBarComponent from '@/components/NavBarComponent.vue';
import FooterSectionComponent from '@/components/FooterSectionComponent.vue';

export default {
  name: 'AppRoot',
  components: {
    NavBarComponent,
    FooterSectionComponent
  },
};
</script>

